export default __webpack_public_path__ + "static/media/icon-transcript.7879bbbb.svg";